import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Disable browser's automatic scroll restoration on refresh
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    // If the URL has a hash (e.g. #quiz), let your existing hash-scroll logic handle it
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}